//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionText,
  Checkbox,
  Radio,
  Typography,
} from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import translations from './FacetsFilters.translations'
import {
  CHECKBOX,
  INPUT_VARIANT,
  MAX_DISPLAYED_FACET_VALUES,
  RADIO,
} from './constants'

export default {
  components: {
    ActionText,
    Checkbox,
    Typography,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    facetValues: {
      type: Array,
      required: true,
    },
    facetFiltered: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    withCount: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isWrappedFacetValues: true,
    }
  },
  computed: {
    translations: () => translations,
    isHigherThanMaxFacet() {
      return this.facetValues.length > MAX_DISPLAYED_FACET_VALUES
    },
    values() {
      return this.facetsValuesWithCount.map((facet) => ({
        ...facet,
        checked: this.facetFiltered.includes(facet.facet_value),
      }))
    },

    facetsValuesWithCount() {
      return this.facetValues.filter(({ count }) => count)
    },

    displayedFacetValues() {
      const facets = this.isWrappedFacetValues
        ? this.values.slice(0, MAX_DISPLAYED_FACET_VALUES)
        : this.values

      return facets.map((facet) => ({
        ...facet,
        props: {
          id: `${this.name}-${facet.facet_value}`,
          variant: INPUT_VARIANT,
          disabled: this.disabled,
          checked: facet.checked,
          ...(this.type === RADIO && { value: facet.facet_value }),
        },
      }))
    },
    moreFacetTranslations() {
      return this.isWrappedFacetValues
        ? this.$t(translations.productFilterMore)
        : this.$t(translations.productFilterLess)
    },
    hasNoFilterChecked() {
      return !this.values.some((v) => v.checked)
    },
    resetFilterProps() {
      return {
        id: `${this.name}-reset`,
        variant: INPUT_VARIANT,
        disabled: this.hasNoFilterChecked,
        checked: this.hasNoFilterChecked,
        ...(this.type === RADIO && { value: this.productFiltersNone }),
      }
    },
    facetTypeComponent() {
      return this.type === CHECKBOX ? Checkbox : Radio
    },
    productFiltersNone() {
      return this.$t(translations.productFilterNone)
    },
  },
  methods: {
    toggleWrap() {
      this.isWrappedFacetValues = !this.isWrappedFacetValues
    },
    resetFacets() {
      this.$emit('change', null)
    },
    emitFacets({ value, isActive }) {
      let filters

      if (this.type === RADIO) {
        if (isActive) {
          filters = [value]
        } else {
          filters = []
        }
      }

      if (this.type === CHECKBOX) {
        if (isActive) {
          filters = [...this.facetFiltered, value]
        } else {
          filters = this.facetFiltered.filter((facet) => facet !== value)
        }
      }

      const payloadChange = isEmpty(filters) ? null : filters

      this.$emit('change', payloadChange)
    },
  },
}
